import React, { Component } from 'react';
import Dropzone from 'react-dropzone';

import ButtonIcon from 'components/helpers/ButtonIcon';
import avatar from 'assets/svg/default_avatar.svg';
import { getValuesAsFormData } from 'utils/form';
import _isEqual from 'lodash/isEqual';

export class UploadProfilePhoto extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uploading: false,
      dropzoneActive: false,
      imageUrl: null
    };
  }

  onDragEnter = () => {
    this.setState({
      dropzoneActive: true
    });
  };

  onDragLeave = () => {
    this.setState({
      dropzoneActive: false
    });
  };

  onDrop = async (acceptedFiles, rejectedFiles) => {
    this.setState({
      dropzoneActive: false
    });

    if (acceptedFiles.length > 0) {
      this.setState({ uploading: true });
      // const params = getValuesAsFormData({ photo: acceptedFiles[0] }, false, false);
      await this.props.onChange(acceptedFiles[0]);

      this.setState({ uploading: false });
    } else if (rejectedFiles.length > 0) {
    }
  };

  removefile = () => {
    this.props.onChange(null);
  };

  displayImage(photo) {
    if (photo && typeof photo === 'string') {
      this.setState({ imageUrl: photo });
    } else if (photo) {
      //display preview of file
      const fr = new FileReader();
      fr.onload = ev => {
        this.setState({ imageUrl: fr.result });
      };
      fr.readAsDataURL(photo);
    } else {
      this.setState({ imageUrl: null });
    }
  }
  componentDidMount() {
    const { photo } = this.props;
    this.displayImage(photo);
  }

  componentDidUpdate(prevProps, prevState) {
    const { photo } = this.props;

    if (!_isEqual(photo, prevProps.photo)) {
      this.displayImage(photo);
    }
  }

  render() {
    const { disabled, className, defaultAvatar, square } = this.props;
    const { dropzoneActive, uploading, imageUrl } = this.state;

    return (
      <div className={'upload-profile-wraper'}>
        <div
          className={`upload-profile position-relative h-100 w-100 ${
            !imageUrl ? 'upload-profile--default' : ''
          } ${square ? 'upload-profile--square' : ''} ${className || ''}`}
        >
          <img
            className={`upload-profile--preview h-100 w-100`}
            src={imageUrl ? `${imageUrl}` : defaultAvatar ? defaultAvatar : avatar}
          />
        </div>

        {!imageUrl ? (
          <div className="upload-profile--handler position-absolute">
            <Dropzone
              accept={'image/*'}
              multiple={false}
              onDrop={this.onDrop.bind(this)}
              onDragEnter={this.onDragEnter.bind(this)}
              onDragLeave={this.onDragLeave.bind(this)}
              disabled={disabled ? disabled : false}
              className={`upload-profile--handler-dropzone py-1 d-flex  align-items-center justify-content-center ${
                dropzoneActive ? 'upload-profile--handler-dropzone-active' : ''
              }`}
            >
              <div className="d-flex">
                <ButtonIcon height={17} width={17} icon={uploading ? 'loader' : 'edit'} />
              </div>
            </Dropzone>
          </div>
        ) : (
          <div
            onClick={() => this.removefile()}
            className="d-inline-flex justify-content-center btn-remove"
          >
            <ButtonIcon height={17} width={17} icon="remove" />
          </div>
        )}
      </div>
    );
  }
}

export default UploadProfilePhoto;



// WEBPACK FOOTER //
// ./src/components/inputs/UploadProfilePhoto.js